import styled from '@emotion/styled/macro';
import { Variables } from '../base';

/** Rows visible before the feed scrolls. */
const FEED_MAX_HEIGHT_PX = 440;

const COLUMNS = '124px 150px 160px minmax(190px, 1fr) minmax(190px, auto)';

export const Feed = styled.section`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const FeedHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

export const FeedTitle = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Table = styled.div`
    overflow: hidden;
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 8px;
    background: ${Variables.ThemeLight.Background3};
`;

export const Scroller = styled.div`
    max-height: ${FEED_MAX_HEIGHT_PX}px;
    overflow: auto;
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: ${COLUMNS};
    gap: 12px;
    min-width: 860px;
    padding: 7px 14px;
`;

export const HeadRow = styled(Row)`
    position: sticky;
    top: 0;
    z-index: 1;
    align-items: center;
    background: ${Variables.ThemeLight.Background2};
    border-bottom: 1px solid ${Variables.ThemeLight.Border2};
    font-family: ${Variables.Fonts.calibre};
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const BodyRow = styled(Row)`
    align-items: center;
`;

export const RowGroup = styled.div`
    &:not(:first-of-type) {
        border-top: 1px solid ${Variables.ThemeLight.Border2};
    }
`;

export const TimeCell = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextMild};
    font-variant-numeric: tabular-nums;
`;

export const JourneyCell = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const PhaseCell = styled(JourneyCell)`
    font-weight: 400;
    color: ${Variables.ThemeLight.TextMild};
`;

export const EventCell = styled.span`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const EventLabel = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const RepeatCount = styled.span`
    margin-left: 6px;
    font-size: 11px;
    font-weight: 600;
    color: ${Variables.ThemeLight.TextMild};
`;

export const ReworkNote = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 11px;
    line-height: 1.3;
    color: ${Variables.ThemeLight.AttentionInverted3};
`;

export const OutcomeCell = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 7px;
`;

export const DeveloperRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    min-width: 860px;
    padding: 0 14px 8px;
`;

export const Tuple = styled.span`
    padding: 3px 6px;
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 4px;
    background: ${Variables.ThemeLight.Background2};
    font-family: ${Variables.Fonts.calibre};
    font-size: 10px;
    font-weight: 500;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextMild};
    font-variant-numeric: tabular-nums;
`;

export const DetailText = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 11px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextXMild};
    text-wrap: pretty;
`;

export const Footnote = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 4px 12px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 11px;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextXMild};
`;

export const EmptyFeed = styled.div`
    padding: 18px 14px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    color: ${Variables.ThemeLight.TextMild};
`;
